/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EquipementEnergyDto } from '../../models/equipement-energy-dto';

export interface GetEquipementsEnergies$Params {
  /**
   * Id equipement pour lequel il faut récupérer les équipements energies.
   */
  idEquipement: string;
}

export function getEquipementsEnergies(
  http: HttpClient,
  rootUrl: string,
  params: GetEquipementsEnergies$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<EquipementEnergyDto>>> {
  const rb = new RequestBuilder(rootUrl, getEquipementsEnergies.PATH, 'get');
  if (params) {
    rb.path('idEquipement', params.idEquipement, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EquipementEnergyDto>>;
    })
  );
}

getEquipementsEnergies.PATH = '/v1/equipements/{idEquipement}/equipement_energies';
